<template>
    <el-dialog :visible.sync="dialogVisible" title="添加" custom-class="custom-dialog" :close-on-click-modal="false"
                @opened="dialogOpen" @closed="dialogClose" width="390px" append-to-body>

        <el-form ref="form" :model="form" :rules="rules" label-width="100px">

            <el-form-item  prop="name" label="维度名称" v-if="form.parentName == ''">
                <el-input v-model="form.name" maxlength="100"  style="width: 200px;"></el-input>
            </el-form-item>

            <el-form-item  prop="name" label="维度名称" v-if="form.parentName !=''">{{ form.parentName }}</el-form-item>

            <el-form-item  prop="name" label="类别名称" v-if="form.parentName !=''"">
                <el-input v-model="form.name" maxlength="100"  style="width: 200px;"></el-input>
            </el-form-item>

            <el-form-item   prop="orderNum" label="排序号">
                <el-input v-model="form.orderNum" maxlength="2" type="number"  style="width: 80px;"></el-input>
            </el-form-item>
        
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogClose()">取消</el-button>
            <el-button :loading="loading" type="primary" @click="save()">确定</el-button>
        </span>    
    </el-dialog>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        name: 'addDimension',
        components: {},
        props: {
            value: Boolean,
            deptId: {
                type: String,
                default() {
                    return ""
                }
            },
            parentId: {
                type: String,
                default() {
                    return ""
                }
            },
            dimension: {
                type: Object,
                default(){
                    return {}
                }
            }
        },
        data(){
            return{
                loading: false,
                dialogVisible: false,
                form:{
                    parentName: "",
                    name: "",
                    orderNum: ""
                },
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            },
            dialogVisible(val) {
                this.$emit('input', val)
            },
        },
        created:function () {
        },
        methods:{
            dialogOpen() {
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }

                if(this.$util.isNotEmpty(this.dimension)){
                    this.form.parentName = this.dimension.text
                }else{
                    this.form.parentName  = ""
                }
            },
            dialogClose(){
                this.dialogVisible = false
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        let parentId = this.$util.isNotEmpty(this.parentId) ? this.parentId:"0"

                        let url= this.clockinDimensionSaveUrl
                        let data = {
                            deptId: this.deptId,
                            parentId: parentId,
                            name: this.form.name,
                            orderNum: this.form.orderNum,
                        };
                        // console.log(JSON.stringify(data))
                        // return

                        this.loading = true
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1)
                                this.dialogVisible=false
                                this.$parent.getData()
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                            this.loading = false
                        }, (err) => {
                            console.log(err)
                            this.loading = false
                        })
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/addDimension.vue